<template>
  <v-row justify="center">
    <v-col cols="auto">
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        max-width="800"
      >
        <v-card :style="{ background: '#F7FAFC' }">
          <v-toolbar class="bg-test" dark>Edit User</v-toolbar>
          <v-card class="mx-5 my-8 py-4 px-5">
            <div class="row d-flex align-items-center">
              <div class="col-12">
                <span>Employee ID</span>
                <v-text-field
                  class="mt-4"
                  fab
                  type="text"
                  v-model="userData.employee_code"
                ></v-text-field>
              </div>

              <div class="col-6">
                <span>User Email</span>
                <v-text-field
                  class="mt-4"
                  v-model="userData.email"
                  fab
                  type="email"
                ></v-text-field>
              </div>

              <div class="col-6">
                <span>User Mobile</span>
                <v-text-field
                  class="mt-4"
                  v-model="userData.mobile"
                  fab
                  type="text"
                ></v-text-field>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-12">
                <span>Select Distributor</span>
                <v-autocomplete
                  deletable-chips
                  multiple
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }"
                  small-chips
                  return-object
                  v-model="userData.distributors"
                  item-text="name"
                  :items="distributorsList"
                ></v-autocomplete>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-12">
                <span>Select Distributor Route</span>
                <v-autocomplete
                  deletable-chips
                  multiple
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }"
                  small-chips
                  return-object
                  v-model="userData.routes"
                  item-text="name"
                  :items="routeList"
                ></v-autocomplete>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-6">
                <span>User Name</span>
                <v-text-field
                  class="mt-4"
                  v-model="userData.username"
                  fab
                  type="text"
                ></v-text-field>
              </div>
              <div class="col-6">
                <span>Password</span>
                <v-text-field
                  class="mt-4"
                  v-model="userData.password"
                  fab
                  type="text"
                ></v-text-field>
              </div>
            </div>
          </v-card>

          <v-card-actions justify="end">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.native="close()">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click.native="saveUser()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      userData: {
        email: "",
        mobile: "",
        username: "",
        password: "",
        routes: [],
        distributors: [],
        asm: [],
        employee_code: "",
      },
    };
  },
  methods: {
    close() {
      this.$emit("update:dialog", false);
    },
    saveUser() {
      let distributors = this.userData.distributors.map((item) => item?.id);
      let routes = this.userData.routes.map((item) => item?.id);

      let error = undefined;

      let payload = {};

      payload = {
        employee_code: this.userData.employee_code,
        email: this.userData.email,
        username: this.userData.username,
        password: this.userData.password,
        mobile: this.userData.mobile,
        distributors: distributors,
        routes: routes,
      };

      if (distributors.length === 0) {
        error = "Please select a distributor";
      } else if (routes.length === 0) {
        error = "Please select a route";
      } else if (payload.username.trim() === "") {
        error = "Please enter a valid username";
      } else if (payload.password === undefined || payload.password === "") {
        error = "Please enter a valid password";
      } else if (payload.email.trim() === "") {
        error = "Please enter a valid email address";
      } else if (payload.mobile.trim() === "") {
        error = "Please enter a valid mobile number";
      }

      if (error) {
        this.$notify({
          title: "Error",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: error,
        });
        return;
      }

      this.$store
        .dispatch("setUserDetails", {
          payload,
          userID: this.id,
        })
        .then(() => this.close())
        .catch((err) => {
          this.$notify({
            title: "Failed to edit user",
            icon: "fa fa-exclamation-triangle",
            type: "danger",
            message: err.toString(),
          });
        });
    },
    fetchUserDetails() {
      this.$store
        .dispatch("fetchUserDetails", { userID: this.id })
        .then(() => {
          this.prepareUser();
        })
        .catch((err) => {
          this.$notify({
            title: "Failed to fetch user details",
            icon: "fa fa-exclamation-triangle",
            type: "danger",
            message: err.toString(),
          });
        });
    },
    prepareUser() {
      this.userData = JSON.parse(JSON.stringify(this.userDetails));

      let routes = this.userData.routes.map((item) =>
        this.routeList.find((ro) => ro.id === item)
      );
      let distributors = this.userData.distributors.map((item) =>
        this.distributorsList.find((dod) => dod.id === item)
      );

      this.userData.routes = routes;
      this.userData.distributors = distributors;
    },
    fetchDistributorList() {
      this.$store.dispatch("fetchDistributorList").catch((err) => {
        this.$notify({
          title: "Failed to fetch distributors list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
    fetchRouteList() {
      this.$store.dispatch("fetchRouteList").catch((err) => {
        this.$notify({
          title: "Failed to fetch route list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
  },
  computed: {
    userDetails() {
      return this.$store.state.usersStore.userDetails;
    },
    distributorsList() {
      return this.$store.state.distributorStore.distributors;
    },
    routeList() {
      return this.$store.state.routeStore.routes;
    },
  },
  props: {
    dialog: {
      default: false,
    },
    id: null,
  },
  watch: {
    id() {
      this.fetchUserDetails();
    },
    dialog() {
      this.fetchUserDetails();
      this.fetchDistributorList();
      this.fetchRouteList();
    },
  },
};
</script>
